<template>
  <div class="tag" :style="getStyleTag">
    {{ getTagInfos.name }}
    <i v-if="deletable" class="tag-delete-btn el-icon-close" @click="removeTag"></i>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ClientTag',
  props: ['idTag', 'cid', 'deletable'],
  computed: {
    ...mapGetters({
      getTagByid: 'infos/getTagByid',
      getClientByid: 'newClients/getClientByid'
    }),
    getTagInfos: function () {
      return this.getTagByid(this.idTag)[1]
    },
    getStyleTag: function () {
      let bgColor = this.getTagInfos.color
      let textColor = '#FFFFFF'
      let color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor
      let r = parseInt(color.substring(0, 2), 16) // hexToR
      let g = parseInt(color.substring(2, 4), 16) // hexToG
      let b = parseInt(color.substring(4, 6), 16) // hexToB
      if (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) {
        textColor = '#1B2238'
      }
      return `background-color:${bgColor}; color:${textColor}`
    }
  },
  methods: {
    ...mapActions({
      updateClient: 'newClients/updateClient'
    }),
    removeTag: function () {
      let mClient = Object.assign({}, this.getClientByid(this.cid))
      let newTags = mClient.tags.slice(0)
      let index = newTags.findIndex((element) => {
        return element === this.idTag
      })
      if (index !== -1) newTags.splice(index, 1)
      mClient.tags = newTags
      this.updateClient(mClient)
    }
  }
}
</script>

<style lang="scss"></style>
